export default function ScreenOrbs({ tone = 'orange' }) {
  const orb1bg = tone === 'indigo'
    ? 'radial-gradient(circle, #6366F1, transparent 70%)'
    : tone === 'purple'
    ? 'radial-gradient(circle, #A78BFA, transparent 70%)'
    : tone === 'pink'
    ? 'radial-gradient(circle, #FF4D8D, transparent 70%)'
    : 'radial-gradient(circle, #FF7E67, transparent 70%)';

  const orb2bg = tone === 'indigo'
    ? 'radial-gradient(circle, #818CF8, transparent 70%)'
    : 'radial-gradient(circle, #FF4D8D, transparent 70%)';

  // The orbs are deliberately positioned outside the frame (right:-160, left:-140)
  // for the bleed effect. Absolutely-positioned overflow still counts toward an
  // ancestor's scrollWidth, so without this clipping wrapper `.screen-root` was
  // ~160px horizontally scrollable on EVERY app screen. Nothing showed it until
  // something called scrollIntoView(), which found that hidden scroll range and
  // shifted the entire app sideways. The wrapper contains the bleed.
  return (
    <div aria-hidden style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
      <div className="orb" style={{ width: 480, height: 480, top: -180, right: -160, background: orb1bg }}/>
      <div className="orb" style={{ width: 600, height: 600, bottom: -260, left: -140, background: orb2bg, opacity: .2 }}/>
    </div>
  );
}
